import React from "react";
import { Box, ButtonBase, Typography } from "@material-ui/core";
import { CustomDialog } from "../CustomDialog";
import { LeadTypeIdEnum } from "../../../Enums";
import { useTranslate } from "../../../Hooks";

//styles
import useStyles from "./styles";

import { SearchHomeIcon, SaleOwnerIcon } from "../../../assets/icons";

function CustomSelectLeadType({ onLeadTypeSelect, open, setOpen }) {
  const styles = useStyles();

  const { translate } = useTranslate("Shared");

  return (
    <CustomDialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      showActions={false}
      title={translate("add-new-lead")}
      subtitle={translate("add-new-lead-subtitle")}
      width={"1000px"}
      content={
        <Box className={styles.containeAddNewLeadsDialog}>
          <ButtonBase
            className={styles.containerBox}
            onClick={() => onLeadTypeSelect(LeadTypeIdEnum.Seeker.leadTypeId)}
          >
            <Box>
              <SearchHomeIcon />
              <Typography className={styles.titleBox}>
                {translate("seeker-lead")}
              </Typography>
              <Typography className={styles.descriptionBox}>
                {translate("seeker-lead-subtitle")}
              </Typography>
            </Box>
          </ButtonBase>
          <ButtonBase
            className={styles.containerBox}
            onClick={() => onLeadTypeSelect(LeadTypeIdEnum.Owner.leadTypeId)}
          >
            <Box>
              <SaleOwnerIcon />
              <Typography className={styles.titleBox}>
                {translate("owner-lead")}
              </Typography>
              <Typography className={styles.descriptionBox}>
                {translate("owner-lead-subtitle")}
              </Typography>
            </Box>
          </ButtonBase>
        </Box>
      }
    />
  );
}
export default CustomSelectLeadType;
